import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputMultiline, InputSwitch } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './owner-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class OwnerCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }
  
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <Input name='phone' label='Phone' value={this.state.datarow.phone} error={this.state.errors?.phone} onChange={this.onChange} />
                <InputEmail name='email' label='Email' value={this.state.datarow.email} error={this.state.errors?.email} onChange={this.onChange} />
                <InputMultiline name='address' label='Address' value={this.state.datarow.address} error={this.state.errors?.address} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Logo' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
           </BaseCreate>
        );
    }     
     
}